import React from 'react'
import { Footer, StyledHr } from '../LayoutTemplate'
import { styled } from 'styled-components'
import { isSektorEnv } from '../../../App'
import { version } from '../../../../package.json'

const currentYear = new Date().getFullYear()

export const CommonFooter = ({
  footerColor,
}: {
  footerColor?: string
}): React.ReactNode => (
  <StyledFooter footerColor={footerColor}>
    <div>
      <StyledHr />
    </div>
    <div>
      <span>
        © {isSektorEnv ? 'Sektor' : 'Mika'} {`${currentYear}`}
      </span>
      <span>v{version}</span>
    </div>
  </StyledFooter>
)

const TemplateFooter: React.FC = React.memo(() => {
  return <CommonFooter />
})

TemplateFooter.displayName = 'TemplateFooter'

export default TemplateFooter

const StyledFooter = styled(Footer)<{ footerColor?: string }>`
  ${props => props.footerColor && `background-color: ${props.footerColor};`}
  :nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-weight: bold;

    span:first-child {
      text-transform: uppercase;
    }

    span:last-child {
      text-transform: none;
      font-weight: normal;
      font-size: 11px;
    }
  }
`
